import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["professionSearch", "addProfessionLink"];

  showProfessionSearch(e) {
    e.preventDefault();
    if (!this.hasProfessionSearchTarget) return;

    this.professionSearchTarget.hidden = false;
    if (this.hasAddProfessionLinkTarget) {
      this.addProfessionLinkTarget.hidden = true;
    }
    this.professionSearchTarget.querySelector("input")?.focus();
  }
}
